import { exportAsImage } from "../../utils/exportAsImage";

export default function TournamentParticipation({ results, activities }) {
  // Merge tournament + result data
  const tournamentData = activities.map((t) => {
    const resForTournament = results.filter((r) => r.tournamentId === t.id);

    const uniquePlayers = new Set(resForTournament.map((r) => r.playerId));
    const medalsWon = resForTournament.filter((r) => r.medal).length;

    const startDate = t.startDate?.toDate
      ? t.startDate.toDate()
      : new Date(t.startDate);
    const endDate = t.endDate?.toDate
      ? t.endDate.toDate()
      : new Date(t.endDate);

    return {
      id: t.id,
      name: t.name,
      date:
        startDate.getTime() === endDate.getTime()
          ? startDate.toLocaleDateString()
          : `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`,
      type: t.rankingType || "Unknown",
      players: uniquePlayers.size,
      medals: medalsWon,
    };
  });

  // Summary grouped by type (AJSS, National, etc)
  const summary = {};
  tournamentData.forEach((t) => {
    if (!summary[t.type]) {
      summary[t.type] = { tournaments: 0, medals: 0 };
    }
    summary[t.type].tournaments += 1;
    summary[t.type].medals += t.medals;
  });

  return (
    <section className="space-y-6">
      {/* Save Button */}
      <div className="flex items-center justify-end mb-2">
        <button
          onClick={() =>
            exportAsImage(
              "tournament-participation-section",
              "tournament_participation"
            )
          }
          className="px-3 py-1 bg-blue-500 text-white rounded"
        >
          Save as Image
        </button>
      </div>

      <div id="tournament-participation-section" className="space-y-6">
        {/* Table A: Tournament Details */}
        <table className="w-full border-collapse border border-gray-300 text-center text-sm">
          <thead className="sticky top-0 bg-gray-100 z-10">
            <tr className="bg-gray-100 text-xs">
              <th className="border border-gray-300 p-2 text-left">Tournament</th>
              <th className="border border-gray-300 p-2">Date</th>
              <th className="border border-gray-300 p-2">No. Players</th>
              <th className="border border-gray-300 p-2">No. Medals Won</th>
            </tr>
          </thead>
          <tbody>
            {tournamentData.map((t) => (
              <tr key={t.id}>
                <td className="border border-gray-300 p-2 text-left">
                  {t.name}
                </td>
                <td className="border border-gray-300 p-2">{t.date}</td>
                <td className="border border-gray-300 p-2">{t.players}</td>
                <td className="border border-gray-300 p-2">{t.medals}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Table B: Summary by Type */}
        <table className="w-full border-collapse border border-gray-300 text-center text-sm">
          <thead className="sticky top-0 bg-gray-100 z-10">
            <tr className="bg-gray-100 text-xs">
              <th className="border border-gray-300 p-2">Tournament Type</th>
              <th className="border border-gray-300 p-2">No. Tournaments</th>
              <th className="border border-gray-300 p-2">No. Medals Won</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(summary).map(([type, counts]) => (
              <tr key={type}>
                <td className="border border-gray-300 p-2 font-medium">
                  {type}
                </td>
                <td className="border border-gray-300 p-2">
                  {counts.tournaments}
                </td>
                <td className="border border-gray-300 p-2">{counts.medals}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
